import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyAlphaDirective } from './only-alpha.directive';



@NgModule({
  declarations: [OnlyAlphaDirective],
  imports: [
    CommonModule
  ],
  exports: [OnlyAlphaDirective]
})
export class OnlyAlphaModule { }
